export const RNA_TYPE_KEY = '__rnaType__';
export const DATA_TYPE_KEY = '__dataType__';

export function getSession(key) {
  return JSON.parse(sessionStorage.getItem(key));
}

export function setSession(key, value) {
  sessionStorage.setItem(key, JSON.stringify(value));
}
